<section class="__master border border-0" [class.--is-desktop]="breakpoints.isDesktop" [class.--expand-listing]="breakpoints.expandListing">
  <ng-content>
  </ng-content>
</section>

@if (breakpoints.isDesktop && !breakpoints.expandListing) {
<section class="__detail">
  <router-outlet #detailOutlet
    (activate)="onOutletActivated($event)"
    (deactivate)="onOutletDeactivated($event)">
  </router-outlet>
</section>
}